import React, { useState } from 'react';


const BlockComment = ({ store }) => {
  return (
    <div className="container">
    
        <div className="col-lg-12">
   
          <textarea className="form-control" id="order_comments" name="order_comments" placeholder="Anmerkungen zur Bestellung z.B. besondere Hinweise für die Lieferung. Keine Support-Anfragen. (optional)" rows="4"></textarea>
        </div>
 
    </div>
  );
};

export default BlockComment;